/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * These identify the different situation modals on the parameter page
 */
enum Qualification {
  SituationScolaire = 'situation-scolaire',
  Diplome = 'diplome',
  Specialite = 'specialite',
  Profession = 'profession,',
}

export default Qualification;
